import React from 'react';
import { TechSection, TechInput, TechSelect } from '../../styles/techComponents';
import { ZONAS_HORARIAS, ThreeCol, FormRow, Label, Hint } from './CreadorPerfilesStyles';

const BloqueAntiBan = (p) => (
  <TechSection title="Limites de Seguridad - Anti-Ban" style={{ marginBottom: '1.5rem' }}>
    <ThreeCol>
      <FormRow><Label>Max Likes/Dia</Label><TechInput type="number" min="0" max="500" value={p.maxLikes} onChange={(e) => p.setMaxLikes(parseInt(e.target.value, 10) || 0)} /><Hint>Limite diario seguro.</Hint></FormRow>
      <FormRow><Label>Max Posts/Dia</Label><TechInput type="number" min="0" max="100" value={p.maxPosts} onChange={(e) => p.setMaxPosts(parseInt(e.target.value, 10) || 0)} /><Hint>Frecuencia maxima.</Hint></FormRow>
      <FormRow><Label>Zona Horaria</Label><TechSelect value={p.zonaHoraria} onChange={(e) => p.setZonaHoraria(e.target.value)}>{ZONAS_HORARIAS.map((z) => <option key={z} value={z}>{z}</option>)}</TechSelect><Hint>Horarios locales.</Hint></FormRow>
      <FormRow><Label>Inicio Sueno</Label><TechInput type="time" value={p.horaInicioSueno} onChange={(e) => p.setHoraInicioSueno(e.target.value)} /><Hint>No actuar desde.</Hint></FormRow>
      <FormRow><Label>Fin Sueno</Label><TechInput type="time" value={p.horaFinSueno} onChange={(e) => p.setHoraFinSueno(e.target.value)} /><Hint>Reanudar a esta hora.</Hint></FormRow>
    </ThreeCol>
  </TechSection>
);

export default BloqueAntiBan;
